var map = {
	"./abap": "13cf",
	"./abap.js": "13cf",
	"./abc": "114d",
	"./abc.js": "114d",
	"./actionscript": "3e38",
	"./actionscript.js": "3e38",
	"./ada": "543f",
	"./ada.js": "543f",
	"./apache_conf": "1bc9",
	"./apache_conf.js": "1bc9",
	"./applescript": "f2cc",
	"./applescript.js": "f2cc",
	"./asciidoc": "edba",
	"./asciidoc.js": "edba",
	"./assembly_x86": "a4fe",
	"./assembly_x86.js": "a4fe",
	"./autohotkey": "27fa",
	"./autohotkey.js": "27fa",
	"./batchfile": "fad8",
	"./batchfile.js": "fad8",
	"./bro": "f9db",
	"./bro.js": "f9db",
	"./c9search": "9ded",
	"./c9search.js": "9ded",
	"./c_cpp": "aef8",
	"./c_cpp.js": "aef8",
	"./cirru": "b087",
	"./cirru.js": "b087",
	"./clojure": "18d0",
	"./clojure.js": "18d0",
	"./cobol": "9b77",
	"./cobol.js": "9b77",
	"./coffee": "16ff",
	"./coffee.js": "16ff",
	"./coldfusion": "62bf",
	"./coldfusion.js": "62bf",
	"./csharp": "92b6",
	"./csharp.js": "92b6",
	"./csound_document": "da0f",
	"./csound_document.js": "da0f",
	"./csound_orchestra": "b56f",
	"./csound_orchestra.js": "b56f",
	"./csound_score": "a7ca",
	"./csound_score.js": "a7ca",
	"./css": "8c18",
	"./css.js": "8c18",
	"./curly": "a5d0",
	"./curly.js": "a5d0",
	"./d": "9504",
	"./d.js": "9504",
	"./dart": "4c76",
	"./dart.js": "4c76",
	"./diff": "56f2",
	"./diff.js": "56f2",
	"./django": "fbfe",
	"./django.js": "fbfe",
	"./dockerfile": "e367",
	"./dockerfile.js": "e367",
	"./dot": "1adb",
	"./dot.js": "1adb",
	"./drools": "d982",
	"./drools.js": "d982",
	"./eiffel": "3df2",
	"./eiffel.js": "3df2",
	"./ejs": "8dd3",
	"./ejs.js": "8dd3",
	"./elixir": "033f",
	"./elixir.js": "033f",
	"./elm": "072e",
	"./elm.js": "072e",
	"./erlang": "edfa",
	"./erlang.js": "edfa",
	"./forth": "b0c8",
	"./forth.js": "b0c8",
	"./fortran": "b3e5",
	"./fortran.js": "b3e5",
	"./ftl": "a309",
	"./ftl.js": "a309",
	"./gcode": "b54a",
	"./gcode.js": "b54a",
	"./gherkin": "9114",
	"./gherkin.js": "9114",
	"./gitignore": "07e6",
	"./gitignore.js": "07e6",
	"./glsl": "549c",
	"./glsl.js": "549c",
	"./gobstones": "6f9f",
	"./gobstones.js": "6f9f",
	"./golang": "4c5b",
	"./golang.js": "4c5b",
	"./graphqlschema": "8b5c",
	"./graphqlschema.js": "8b5c",
	"./groovy": "5f48",
	"./groovy.js": "5f48",
	"./haml": "757b",
	"./haml.js": "757b",
	"./handlebars": "fe1a",
	"./handlebars.js": "fe1a",
	"./haskell": "03d0",
	"./haskell.js": "03d0",
	"./haskell_cabal": "1d30",
	"./haskell_cabal.js": "1d30",
	"./haxe": "0bab",
	"./haxe.js": "0bab",
	"./hjson": "ca71",
	"./hjson.js": "ca71",
	"./html": "e1a9",
	"./html.js": "e1a9",
	"./html_elixir": "9556",
	"./html_elixir.js": "9556",
	"./html_ruby": "39f1",
	"./html_ruby.js": "39f1",
	"./ini": "fe8a",
	"./ini.js": "fe8a",
	"./io": "1254",
	"./io.js": "1254",
	"./jack": "681f",
	"./jack.js": "681f",
	"./jade": "755e",
	"./jade.js": "755e",
	"./java": "a849",
	"./java.js": "a849",
	"./javascript": "6a21",
	"./javascript.js": "6a21",
	"./json": "b039",
	"./json.js": "b039",
	"./jsoniq": "a72c",
	"./jsoniq.js": "a72c",
	"./jsp": "75d4",
	"./jsp.js": "75d4",
	"./jssm": "c9d7",
	"./jssm.js": "c9d7",
	"./jsx": "54f1",
	"./jsx.js": "54f1",
	"./julia": "6e43",
	"./julia.js": "6e43",
	"./kotlin": "00bf",
	"./kotlin.js": "00bf",
	"./latex": "655b",
	"./latex.js": "655b",
	"./lean": "ce02",
	"./lean.js": "ce02",
	"./less": "6af6",
	"./less.js": "6af6",
	"./liquid": "aee8",
	"./liquid.js": "aee8",
	"./lisp": "3f9e",
	"./lisp.js": "3f9e",
	"./live_script": "364d",
	"./live_script.js": "364d",
	"./livescript": "b89a",
	"./livescript.js": "b89a",
	"./logiql": "6d8d",
	"./logiql.js": "6d8d",
	"./lsl": "fe48",
	"./lsl.js": "fe48",
	"./lua": "4f63",
	"./lua.js": "4f63",
	"./luapage": "37ab",
	"./luapage.js": "37ab",
	"./lucene": "06ea",
	"./lucene.js": "06ea",
	"./makefile": "7cd2",
	"./makefile.js": "7cd2",
	"./markdown": "0950",
	"./markdown.js": "0950",
	"./mask": "0fe2",
	"./mask.js": "0fe2",
	"./matlab": "c520",
	"./matlab.js": "c520",
	"./maze": "f4a9",
	"./maze.js": "f4a9",
	"./mel": "ead9",
	"./mel.js": "ead9",
	"./mips_assembler": "a2db",
	"./mips_assembler.js": "a2db",
	"./mipsassembler": "cf2f",
	"./mipsassembler.js": "cf2f",
	"./mushcode": "da8f",
	"./mushcode.js": "da8f",
	"./mysql": "e559",
	"./mysql.js": "e559",
	"./nix": "cc00",
	"./nix.js": "cc00",
	"./nsis": "27d8",
	"./nsis.js": "27d8",
	"./objectivec": "0766",
	"./objectivec.js": "0766",
	"./ocaml": "d241",
	"./ocaml.js": "d241",
	"./pascal": "f641",
	"./pascal.js": "f641",
	"./perl": "dd70",
	"./perl.js": "dd70",
	"./pgsql": "e179",
	"./pgsql.js": "e179",
	"./php": "1edc",
	"./php.js": "1edc",
	"./pig": "1842",
	"./pig.js": "1842",
	"./plain_text": "0991",
	"./plain_text.js": "0991",
	"./powershell": "aefc",
	"./powershell.js": "aefc",
	"./praat": "d779",
	"./praat.js": "d779",
	"./prolog": "7950",
	"./prolog.js": "7950",
	"./properties": "477e",
	"./properties.js": "477e",
	"./protobuf": "3af0",
	"./protobuf.js": "3af0",
	"./python": "8ef6",
	"./python.js": "8ef6",
	"./r": "3d06",
	"./r.js": "3d06",
	"./razor": "a2ca",
	"./razor.js": "a2ca",
	"./rdoc": "0d27",
	"./rdoc.js": "0d27",
	"./red": "7fbf",
	"./red.js": "7fbf",
	"./rhtml": "0970",
	"./rhtml.js": "0970",
	"./rst": "d342",
	"./rst.js": "d342",
	"./ruby": "9b41",
	"./ruby.js": "9b41",
	"./rust": "b98c",
	"./rust.js": "b98c",
	"./sass": "d366",
	"./sass.js": "d366",
	"./scad": "d916",
	"./scad.js": "d916",
	"./scala": "541c",
	"./scala.js": "541c",
	"./scheme": "e066",
	"./scheme.js": "e066",
	"./scss": "3d96",
	"./scss.js": "3d96",
	"./sh": "4e93",
	"./sh.js": "4e93",
	"./sjs": "5ff4",
	"./sjs.js": "5ff4",
	"./smarty": "7f46",
	"./smarty.js": "7f46",
	"./snippets": "6659",
	"./snippets.js": "6659",
	"./soy_template": "fa95",
	"./soy_template.js": "fa95",
	"./space": "8d0d",
	"./space.js": "8d0d",
	"./sparql": "b06d",
	"./sparql.js": "b06d",
	"./sql": "6e63",
	"./sql.js": "6e63",
	"./sqlserver": "cc8b",
	"./sqlserver.js": "cc8b",
	"./stylus": "6127",
	"./stylus.js": "6127",
	"./svg": "93c5",
	"./svg.js": "93c5",
	"./swift": "2387",
	"./swift.js": "2387",
	"./swig": "6f26",
	"./swig.js": "6f26",
	"./tcl": "da3f",
	"./tcl.js": "da3f",
	"./tex": "b643",
	"./tex.js": "b643",
	"./text": "24b9",
	"./text.js": "24b9",
	"./textile": "e38e",
	"./textile.js": "e38e",
	"./toml": "5920",
	"./toml.js": "5920",
	"./tsx": "037a",
	"./tsx.js": "037a",
	"./turtle": "b82a",
	"./turtle.js": "b82a",
	"./twig": "01e0",
	"./twig.js": "01e0",
	"./typescript": "af90",
	"./typescript.js": "af90",
	"./vala": "72cd",
	"./vala.js": "72cd",
	"./vbscript": "9f73",
	"./vbscript.js": "9f73",
	"./velocity": "02c4",
	"./velocity.js": "02c4",
	"./verilog": "6489",
	"./verilog.js": "6489",
	"./vhdl": "20b8",
	"./vhdl.js": "20b8",
	"./wollok": "9d30",
	"./wollok.js": "9d30",
	"./xml": "058d",
	"./xml.js": "058d",
	"./xquery": "7dd5",
	"./xquery.js": "7dd5",
	"./yaml": "ec5e",
	"./yaml.js": "ec5e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "baa7";